// =============================================================================
// ENVIRONMENT URLS
// Switch environments by commenting / uncommenting a block — only one block may be active.
// Both can be overridden per machine from a .env.local file (git ignored).

// Staging
//export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || "https://bac-stg.rizemtg.com";
//export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "https://ambitious-pond-08004150f.4.azurestaticapps.net";

// Production
export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || "https://branchadmincenter-apiprod-hje4gkb5h6b0cghq.eastus-01.azurewebsites.net";
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "https://branchonboarding.rizemtg.com";

// --- LOCAL DEVELOPMENT ---

// export const BACKEND_API_URL = "http://127.0.0.1:8000";
// export const FRONTEND_URL = "http://localhost:3000";

export const APP_CURRENT_VERSION = "1.0.6";

export const ONBOARDING_MAX_STEPS = 19;

export const ONBOARDING_FINAL_STEP = 20;

export const BRANCH_NAMES_API_URL = "https://prod-85.eastus.logic.azure.com:443/workflows/98c59ee99a0946c595ea288657855645/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=gdCHQN0E6wT_Fb0UIEKfOM0uX17LIyL_theldMzK6dY";

export const MANAGER_NAMES_API_URL = "https://prod-80.eastus.logic.azure.com:443/workflows/451a6faf3bb54024a4e04adab1f67da4/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=ON_U2ugJG3s8CXnJWCfezzzHS90zIMtUNxOPtXlJ6xM";

export const ADMIN_LINK_GENERATION_FORM_DROPDOWN_API_URL = "https://prod-17.northcentralus.logic.azure.com:443/workflows/f76d3e6fb6cc40ea9871430e9f801d8f/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=9hLPTE74cRixM8LwxCYAqu0QgbnVmZcasPruXBPSvME"
